<a class="skip-link" href="#main-content">Skip to main content</a>

<p-toast position="top-right" />

<div class="app-container">
  <app-loader></app-loader>
  <app-pull-to-refresh></app-pull-to-refresh>
  <header role="banner">
    <div class="header-content">
      <a class="logo"
        routerLink="/"
        aria-label="Jagannath Temple — go to home">
        <img src="assets/logo.png"
          alt=""
          class="logo-img"
          width="28"
          height="28">
        <span class="logo-title">{{ title }}</span>
      </a>
      @if (isAuthenticated) {
        <button
          pButton
          type="button"
          class="user-icon p-button-text p-button-rounded"
          aria-label="Open account menu"
          aria-haspopup="menu"
          (click)="menu.toggle($event)">
          <i class="pi pi-user" aria-hidden="true"></i>
        </button>
      }
      <p-menu #menu
        [model]="menuItems"
        [popup]="true"
        appendTo="body"></p-menu>
    </div>
  </header>

  @if (isAuthenticated) {
    <nav class="main-nav"
      aria-label="Main navigation">
      <ul>
        @if (isAdmin) {
          <li>
            <a routerLink="/dashboard"
              routerLinkActive="active"
              [attr.aria-current]="isActiveRoute('/dashboard') ? 'page' : null">
              <i class="pi pi-chart-bar" aria-hidden="true"></i>
              <span>Dashboard</span>
            </a>
          </li>
        }
        <li>
          <a routerLink="/bookings"
            routerLinkActive="active"
            [attr.aria-current]="isActiveRoute('/bookings') ? 'page' : null">
            <i class="pi pi-calendar" aria-hidden="true"></i>
            <span>Bookings</span>
          </a>
        </li>
        <li>
          <a routerLink="/new-booking"
            routerLinkActive="active"
            [attr.aria-current]="isActiveRoute('/new-booking') ? 'page' : null">
            <i class="pi pi-plus-circle" aria-hidden="true"></i>
            <span>New Booking</span>
          </a>
        </li>
      </ul>
    </nav>
  }

  <main id="main-content"
    [class.no-nav]="!isAuthenticated"
    role="main"
    tabindex="-1">
    <router-outlet />
  </main>
</div>

  <!-- Add Update Dialog -->
  <p-dialog [(visible)]="showUpdateDialog"
    [modal]="true"
    [style]="{width: '400px'}"
    [closable]="false"
    [closeOnEscape]="false"
    [showHeader]="true"
    header="New Update Available"
    styleClass="update-dialog">

    <div class="update-content">
      <div class="update-icon">
        <i class="pi pi-refresh"></i>
      </div>
      <div class="update-text">
        <h3>Application Update</h3>
        <p>A new version of the application is available. Please update to the latest version for improved features and
        bug fixes.</p>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <button pButton
          type="button"
          label="Update Now"
          icon="pi pi-check"
          class="p-button-primary"
        (click)="updateApplication()"></button>
      </div>
    </ng-template>
  </p-dialog>